import { render, staticRenderFns } from "./autenticar-dni.vue?vue&type=template&id=4ef368ce"
import script from "./autenticar-dni.vue?vue&type=script&lang=js"
export * from "./autenticar-dni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports